import { collection, query, getDocs } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';
import type { User } from '@/types';

export async function searchUsers(role: string, searchQuery: string = ''): Promise<User[]> {
  try {
    const usersRef = collection(db, 'users');
    const snapshot = await getDocs(usersRef);
    
    // Filter users by role in memory to avoid complex queries
    let users = snapshot.docs
      .map(doc => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt?.toDate(),
        updatedAt: doc.data().updatedAt?.toDate()
      }))
      .filter(user => 
        user.roles?.some((r: any) => 
          r.role === role && r.isActive === true
        )
      ) as User[];

    // Apply search filter if provided
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      users = users.filter(user => 
        user.firstNameEn?.toLowerCase().includes(query) ||
        user.lastNameEn?.toLowerCase().includes(query) ||
        user.email?.toLowerCase().includes(query)
      );
    }

    return users;
  } catch (error) {
    handleFirebaseError(error, 'Error searching users');
    return [];
  }
}